// src/utils/translation.js

export const translations = {
  en: {
    toolNames: {
      "Image To Pdf": "Image To PDF",
      "Jpg To Pdf": "JPG To PDF",
      "Png To Pdf": "PNG To PDF",
      "Pdf To Gif": "PDF To GIF",
      "Pdf Converter": "PDF Converter",
      "Pdf To Png": "PDF To PNG",
      "Pdf To Jpg": "PDF To JPG",
      "Pdf To Csv": "PDF To CSV",
      "Pdf To Excel": "PDF To Excel",
      "Pdf To Word": "PDF To Word",
      "Pdf To Json": "PDF To JSON",
      "Pdf To Ppt": "PDF To PPT",
      "Compare Text": "Compare Text",
      "JSON Editor & ": "JSON Editor",
      "Pdf To Pptx": "PDF To PPTX",
      "Pdf To Txt": "PDF To TXT",
      "Pdf To Docx": "PDF To DOCX",
      "Merge PDFs": "Merge PDFs",
      "Split PDF": "Split PDF",
    },

    pages: {
      pdfTools: {
        title: "Online PDF Tools",
        subtitle:
          "A suite of free tools to manage, convert, and edit your PDF files with ease.",
      },
      annotatePdf: {
        title: "Annotate PDF",
        annotationLabel: "Annotation Text:",
        pageNumberLabel: "Page Number:",
        saveButton: "Save and Download Annotated PDF",
      },
      compareText: {
        title: "Compare Text Files",
        placeholder1: "Enter or paste text for File 1",
        placeholder2: "Enter or paste text for File 2",
        compareButton: "Compare Text",
        comparisonResultTitle: "Comparison",
        file1ResultTitle: "File 1",
        file2ResultTitle: "File 2",
        identicalFilesTitle: "The two files are identical.",
        identicalFilesSubtitle:
          "There is no difference to show between these two files.",
      },
      editPdfMetadata: {
        title: "Edit PDF Metadata",
        uploadLabel: "Upload PDF:",
        chooseFileButton: "Choose File",
        selectedFileLabel: "Selected File:",
        metaTitleLabel: "Title:",
        metaAuthorLabel: "Author:",
        metaSubjectLabel: "Subject:",
        saveButton: "Save and Download PDF",
      },
      imageToPdf: {
        title: "Convert Image to PDF",
        dropzoneIdle: "Choose or Drop files here",
        dropzoneActive: "Image file selected",
        resultTitle: "Converted PDF",
        downloadButton: "Download",
      },
      // New section for the JPG to PDF page
      jpgToPdf: {
        title: "Convert JPG to PDF",
        dropzoneIdle: "Choose or Drop files here",
        dropzoneActive: "Image file selected",
        resultTitle: "Converted PDF Preview",
        downloadButton: "Download",
      },
      jsonEditor: {
        title: "JSON Editor & Converter",
        uploadButton: "Upload JSON File",
        validateButton: "Validate",
        tabSpace2: "2 Tab Space",
        tabSpace3: "3 Tab Space",
        tabSpace4: "4 Tab Space",
        formatButton: "Format / Beautify",
        minifyButton: "Minify / Compact",
        convertLabel: "Convert JSON to",
        convertToCsv: "Json to CSV",
        convertToXml: "Json to XML",
        convertToYaml: "Json to YAML",
        convertButton: "Convert",
        downloadButton: "Download",
      },
      mergePdfs: {
        title: "Merge PDFs",
        dropzoneIdle: "Drag & drop PDF files or click to choose",
        dropzoneActive: "{count} file(s) selected",
        mergeButton: "Merge PDFs",
        loadingText: "Merging PDFs...",
        downloadReadyText: "Merged PDF is ready for download:",
        downloadButton: "Download",
      },
      pdfConverter: {
        title: "PDF Converter",
        dropzoneIdle: "Drag & drop a file or click to choose",
        dropzoneActive: "File selected",
        downloadButton: "Download",
        loadingText: "Converting...",
      },
      pdfToCsv: {
        title: "Convert PDF to CSV",
        dropzoneIdle: "Choose or Drop files here",
        dropzoneActive: "PDF file selected",
        loadingText: "Loading PDF...",
        downloadButton: "Download",
      },
      pdfToDocx: {
        title: "Convert PDF to DOCX",
        dropzoneIdle: "Choose or Drop files here",
        downloadButton: "Download",
        loadingText: "Converting... Please wait.",
      },
      pdfToExcel: {
        title: "Convert PDF to Excel",
        dropzoneIdle: "Choose or Drop files here",
        dropzoneActive: "PDF file selected",
        downloadButton: "Download",
      },
      pdfToGif: {
        title: "Convert PDF to GIF",
        dropzoneIdle: "Choose or Drop files here",
        dropzoneActive: "File selected",
        convertButton: "Convert to GIF",
        loadingText: "Converting...",
        resultTitle: "Converted GIF Preview",
        downloadButton: "Download",
      },
      pdfToJpg: {
        title: "Convert PDF to JPG",
        dropzoneIdle: "Choose or Drop files here",
        dropzoneActive: "PDF file selected",
        resultTitle: "Converted JPG Pages",
        downloadButton: "Download",
        downloadAllButton: "Download All as ZIP",
      },
      pdfToJson: {
        title: "Convert PDF to JSON",
        dropzoneIdle: "Choose or Drop files here",
        dropzoneActive: "PDF file selected",
        downloadButton: "Download",
      },
      pdfToPng: {
        title: "Convert PDF to PNG",
        dropzoneIdle: "Choose or Drop files here",
        dropzoneActive: "PDF file selected",
        resultTitle: "Converted PNG Pages",
        downloadButton: "Download",
        downloadAllButton: "Download All as ZIP",
      },
      pdfToPpt: {
        title: "Convert PDF to PPT",
        dropzoneIdle: "Choose or Drop files here",
        downloadButton: "Download",
      },
      pdfToPptx: {
        title: "Convert PDF to PPTX",
        dropzoneIdle: "Choose or Drop files here",
        downloadButton: "Download",
        loadingText: "Processing... Please wait.",
      },
      pdfToRtf: {
        title: "Convert PDF to RTF",
        dropzoneIdle: "Choose Or Drop files here",
        loadingText: "Converting file...",
        downloadButton: "Download",
      },
      pdfToTxt: {
        title: "Convert PDF to TXT",
        dropzoneIdle: "Choose or Drop files here",
        downloadButton: "Download",
      },
      pdfToWord: {
        title: "Convert PDF to Word",
        dropzoneIdle: "Choose or Drop files here",
        dropzoneActive: "PDF file selected",
        loadingText: "Converting...",
        downloadButton: "Download",
      },
      pngToPdf: {
        title: "Convert PNG to PDF",
        dropzoneIdle: "Choose or Drop files here",
        dropzoneActive: "Image file selected",
        resultTitle: "Converted PDF Preview",
        downloadButton: "Download PDF",
      },
      splitPdf: {
        title: "Split PDF",
        dropzoneIdle: "Drag & drop a file or click to choose",
        splitButton: "Split PDF",
        loadingText: "Splitting...",
        resultTitle: "Split Pages",
        pageLabel: "Page {pageNumber}",
      },
    },

    alerts: {
      uploadFile: "Please upload a PDF file.",
      enterAnnotation: "Please enter annotation text.",
      invalidPage: "Invalid page number. This PDF has {pageCount} pages.",
      invalidImageType: "Please upload a valid image file (PNG or JPEG).",
      uploadFirst: "Please upload an image first.",
      invalidJson: "Invalid JSON format",
      uploadJsonFile: "Please upload a valid JSON file",
      jsonIsValid: "JSON is valid",
      jsonNotArray: "JSON must be an array of objects to convert to CSV",
      selectConversion: "Please select a conversion type",
      conversionSuccess: "Conversion successful!",
      conversionError: "Error during conversion. Please check the input JSON.",
      selectAtLeastTwoPdfs: "Please select at least two PDF files to merge.",
      invalidFileConverter:
        "Please upload a valid image (JPEG, PNG) or a text-based file (CSV, TXT, JSON, XML).",
      unsupportedImageType: "Unsupported image type",
      pdfExtractionError:
        "An error occurred during the extraction process. Please try again.",
      uploadValidPdf: "Please upload a valid PDF file.",
      pdfToDocxError: "There was an error while converting the PDF.",
      pdfProcessingError: "Error while processing PDF.",
      conversionErrorGeneral: "An error occurred during conversion.",
      fileReadError: "Error reading file.",
      pdfExtractError: "Failed to extract text from PDF.",
      noTextExtracted: "No text extracted from the PDF.",
      conversionProcessError:
        "An error occurred during the conversion process. Please try again.",
      fileReadErrorRetry: "Error reading the file. Please try again.",
      wordGenerateError: "Failed to generate Word document.",
      uploadPng: "Please upload a valid PNG image file.",
      uploadPngFirst: "Please upload a PNG image first.",
      selectPdfToSplit: "Please select a PDF file to split.",
    },
  },

  fr: {
    toolNames: {
      "Image To Pdf": "Image en PDF",
      "Jpg To Pdf": "JPG en PDF",
      "Png To Pdf": "PNG en PDF",
      "Pdf To Gif": "PDF en GIF",
      "Pdf Converter": "Convertisseur PDF",
      "Pdf To Png": "PDF en PNG",
      "Pdf To Jpg": "PDF en JPG",
      "Pdf To Csv": "PDF en CSV",
      "Pdf To Excel": "PDF en Excel",
      "Pdf To Word": "PDF en Word",
      "Pdf To Json": "PDF en JSON",
      "Pdf To Ppt": "PDF en PPT",
      "Compare Text": "Comparer le Texte",
      "JSON Editor & ": "Éditeur JSON",
      "Pdf To Pptx": "PDF en PPTX",
      "Pdf To Txt": "PDF en TXT",
      "Pdf To Docx": "PDF en DOCX",
      "Merge PDFs": "Fusionner les PDF",
      "Split PDF": "Diviser le PDF",
    },

    pages: {
      pdfTools: {
        title: "Outils PDF en Ligne",
        subtitle:
          "Une suite d'outils gratuits pour gérer, convertir et modifier vos fichiers PDF en toute simplicité.",
      },
      annotatePdf: {
        title: "Annoter le PDF",
        annotationLabel: "Texte de l'annotation :",
        pageNumberLabel: "Numéro de page :",
        saveButton: "Enregistrer et télécharger le PDF annoté",
      },
      compareText: {
        title: "Comparer des fichiers texte",
        placeholder1: "Entrez ou collez le texte du Fichier 1",
        placeholder2: "Entrez ou collez le texte du Fichier 2",
        compareButton: "Comparer le texte",
        comparisonResultTitle: "Comparaison",
        file1ResultTitle: "Fichier 1",
        file2ResultTitle: "Fichier 2",
        identicalFilesTitle: "Les deux fichiers sont identiques.",
        identicalFilesSubtitle:
          "Il n'y a aucune différence à montrer entre ces deux fichiers.",
      },
      editPdfMetadata: {
        title: "Modifier les métadonnées du PDF",
        uploadLabel: "Télécharger le PDF :",
        chooseFileButton: "Choisir un fichier",
        selectedFileLabel: "Fichier sélectionné :",
        metaTitleLabel: "Titre :",
        metaAuthorLabel: "Auteur :",
        metaSubjectLabel: "Sujet :",
        saveButton: "Enregistrer et télécharger le PDF",
      },
      imageToPdf: {
        title: "Convertir une image en PDF",
        dropzoneIdle: "Choisissez ou déposez des fichiers ici",
        dropzoneActive: "Fichier image sélectionné",
        resultTitle: "PDF converti",
        downloadButton: "Télécharger",
      },
      // New section for the JPG to PDF page in French
      jpgToPdf: {
        title: "Convertir JPG en PDF",
        dropzoneIdle: "Choisissez ou déposez des fichiers ici",
        dropzoneActive: "Fichier image sélectionné",
        resultTitle: "Aperçu du PDF converti",
        downloadButton: "Télécharger",
      },
      jsonEditor: {
        title: "Éditeur et Convertisseur JSON",
        uploadButton: "Télécharger un fichier JSON",
        validateButton: "Valider",
        tabSpace2: "Espace de 2 tabulations",
        tabSpace3: "Espace de 3 tabulations",
        tabSpace4: "Espace de 4 tabulations",
        formatButton: "Formater / Embellir",
        minifyButton: "Minifier / Compacter",
        convertLabel: "Convertir JSON en",
        convertToCsv: "Json en CSV",
        convertToXml: "Json en XML",
        convertToYaml: "Json en YAML",
        convertButton: "Convertir",
        downloadButton: "Télécharger",
      },
      mergePdfs: {
        title: "Fusionner des PDF",
        dropzoneIdle:
          "Glissez-déposez des fichiers PDF ou cliquez pour choisir",
        dropzoneActive: "{count} fichier(s) sélectionné(s)",
        mergeButton: "Fusionner les PDF",
        loadingText: "Fusion en cours...",
        downloadReadyText: "Le PDF fusionné est prêt à être téléchargé :",
        downloadButton: "Télécharger",
      },
      pdfConverter: {
        title: "Convertisseur PDF",
        dropzoneIdle: "Glissez-déposez un fichier ou cliquez pour choisir",
        dropzoneActive: "Fichier sélectionné",
        downloadButton: "Télécharger",
        loadingText: "Conversion en cours...",
      },
      pdfToCsv: {
        title: "Convertir PDF en CSV",
        dropzoneIdle: "Choisissez ou déposez des fichiers ici",
        dropzoneActive: "Fichier PDF sélectionné",
        loadingText: "Chargement du PDF...",
        downloadButton: "Télécharger",
      },
      pdfToDocx: {
        title: "Convertir PDF en DOCX",
        dropzoneIdle: "Choisissez ou déposez des fichiers ici",
        downloadButton: "Télécharger",
        loadingText: "Conversion en cours... Veuillez patienter.",
      },
      pdfToExcel: {
        title: "Convertir PDF en Excel",
        dropzoneIdle: "Choisissez ou déposez des fichiers ici",
        dropzoneActive: "Fichier PDF sélectionné",
        downloadButton: "Télécharger",
      },
      pdfToGif: {
        title: "Convertir PDF en GIF",
        dropzoneIdle: "Choisissez ou déposez des fichiers ici",
        dropzoneActive: "Fichier sélectionné",
        convertButton: "Convertir en GIF",
        loadingText: "Conversion en cours...",
        resultTitle: "Aperçu du GIF converti",
        downloadButton: "Télécharger",
      },
      pdfToJpg: {
        title: "Convertir PDF en JPG",
        dropzoneIdle: "Choisissez ou déposez des fichiers ici",
        dropzoneActive: "Fichier PDF sélectionné",
        resultTitle: "Pages JPG converties",
        downloadButton: "Télécharger",
        downloadAllButton: "Tout télécharger en ZIP",
      },
      pdfToJson: {
        title: "Convertir PDF en JSON",
        dropzoneIdle: "Choisissez ou déposez des fichiers ici",
        dropzoneActive: "Fichier PDF sélectionné",
        downloadButton: "Télécharger",
      },
      pdfToPng: {
        title: "Convertir PDF en PNG",
        dropzoneIdle: "Choisissez ou déposez des fichiers ici",
        dropzoneActive: "Fichier PDF sélectionné",
        resultTitle: "Pages PNG converties",
        downloadButton: "Télécharger",
        downloadAllButton: "Tout télécharger en ZIP",
      },
      pdfToPpt: {
        title: "Convertir PDF en PPT",
        dropzoneIdle: "Choisissez ou déposez des fichiers ici",
        downloadButton: "Télécharger",
      },
      pdfToPptx: {
        title: "Convertir PDF en PPTX",
        dropzoneIdle: "Choisissez ou déposez des fichiers ici",
        downloadButton: "Télécharger",
        loadingText: "Traitement en cours... Veuillez patienter.",
      },
      pdfToRtf: {
        title: "Convertir PDF en RTF",
        dropzoneIdle: "Choisissez ou déposez des fichiers ici",
        loadingText: "Conversion du fichier...",
        downloadButton: "Télécharger",
      },
      pdfToTxt: {
        title: "Convertir PDF en TXT",
        dropzoneIdle: "Choisissez ou déposez des fichiers ici",
        downloadButton: "Télécharger",
      },
      pdfToWord: {
        title: "Convertir PDF en Word",
        dropzoneIdle: "Choisissez ou déposez des fichiers ici",
        dropzoneActive: "Fichier PDF sélectionné",
        loadingText: "Conversion en cours...",
        downloadButton: "Télécharger",
      },
      pngToPdf: {
        title: "Convertir PNG en PDF",
        dropzoneIdle: "Choisissez ou déposez des fichiers ici",
        dropzoneActive: "Fichier image sélectionné",
        resultTitle: "Aperçu du PDF converti",
        downloadButton: "Télécharger le PDF",
      },
      splitPdf: {
        title: "Diviser le PDF",
        dropzoneIdle: "Glissez-déposez un fichier ou cliquez pour choisir",
        splitButton: "Diviser le PDF",
        loadingText: "Division en cours...",
        resultTitle: "Pages divisées",
        pageLabel: "Page {pageNumber}",
      },
    },

    alerts: {
      uploadFile: "Veuillez télécharger un fichier PDF.",
      enterAnnotation: "Veuillez saisir le texte de l'annotation.",
      invalidPage: "Numéro de page invalide. Ce PDF a {pageCount} pages.",
      invalidImageType:
        "Veuillez télécharger un fichier image valide (PNG ou JPEG).",
      uploadFirst: "Veuillez d'abord télécharger une image.",
      invalidJson: "Format JSON invalide",
      uploadJsonFile: "Veuillez télécharger un fichier JSON valide",
      jsonIsValid: "Le JSON est valide",
      jsonNotArray:
        "Le JSON doit être un tableau d'objets pour être converti en CSV",
      selectConversion: "Veuillez sélectionner un type de conversion",
      conversionSuccess: "Conversion réussie !",
      conversionError:
        "Erreur lors de la conversion. Veuillez vérifier le JSON d'entrée.",
      selectAtLeastTwoPdfs:
        "Veuillez sélectionner au moins deux fichiers PDF à fusionner.",
      invalidFileConverter:
        "Veuillez télécharger une image valide (JPEG, PNG) ou un fichier texte (CSV, TXT, JSON, XML).",
      unsupportedImageType: "Type d'image non supporté",
      pdfExtractionError:
        "Une erreur est survenue lors du processus d'extraction. Veuillez réessayer.",
      uploadValidPdf: "Veuillez télécharger un fichier PDF valide.",
      pdfToDocxError: "Une erreur est survenue lors de la conversion du PDF.",
      pdfProcessingError: "Erreur lors du traitement du PDF.",
      conversionErrorGeneral: "Une erreur est survenue lors de la conversion.",
      fileReadError: "Erreur de lecture du fichier.",
      pdfExtractError: "Échec de l'extraction du texte du PDF.",
      noTextExtracted: "Aucun texte n'a été extrait du PDF.",
      conversionProcessError:
        "Une erreur est survenue lors du processus de conversion. Veuillez réessayer.",
      fileReadErrorRetry: "Erreur de lecture du fichier. Veuillez réessayer.",
      wordGenerateError: "Échec de la génération du document Word.",
      uploadPng: "Veuillez télécharger un fichier image PNG valide.",
      uploadPngFirst: "Veuillez d'abord télécharger une image PNG.",
      selectPdfToSplit: "Veuillez sélectionner un fichier PDF à diviser.",
    },
  },
};

/**
 * Custom hook to determine the current language from the URL.
 * @returns {string} The current language code ('fr' or 'en').
 */
export const useLanguage = () => {
  if (typeof window !== "undefined") {
    const pathname = window.location.pathname;
    return pathname.startsWith("/fr") ? "fr" : "en";
  }
  return "en"; // Default language for server-side rendering
};

/**
 * Gets a translated string for a given key.
 * @param {string} key - The dot-separated key for the translation (e.g., 'pages.pdfTools.title').
 * @param {string} [lang='en'] - The language code.
 * @returns {string} The translated string or the key itself if not found.
 */
export const getTranslation = (key, lang = "en") => {
  const keys = key.split(".");
  let value = translations[lang];

  for (const k of keys) {
    if (value && typeof value === "object" && k in value) {
      value = value[k];
    } else {
      let fallbackValue = translations.en;
      for (const fallbackKey of keys) {
        if (
          fallbackValue &&
          typeof fallbackValue === "object" &&
          fallbackKey in fallbackValue
        ) {
          fallbackValue = fallbackValue[fallbackKey];
        } else {
          return keys[keys.length - 1];
        }
      }
      return fallbackValue;
    }
  }

  return typeof value === "string" ? value : keys[keys.length - 1];
};

/**
 * Returns a localized path based on the current language.
 * @param {string} path - The original path (e.g., '/PdfToWord').
 * @param {string} lang - The current language code ('fr' or 'en').
 * @returns {string} The localized path (e.g., '/fr/PdfToWord').
 */
export const getLocalizedPath = (path, lang) => {
  if (!path) return path;
  if (path.startsWith('http') || path.startsWith('mailto:')) return path; // Don't localize external links
  if (lang === 'fr' && !path.startsWith('/fr')) {
    return `/fr${path.startsWith('/') ? '' : '/'}${path}`;
  }
  return path;
};
